import angular from 'angular';
import sendEmail from './sendEmail';
import SendEmailComponentCtrl from './SendEmailComponentCtrl';

export default angular
  .module('components.sendEmail', [])
  .controller('SendEmailComponentCtrl', SendEmailComponentCtrl)
  .component('sendEmail', sendEmail).name;
